import { Text } from '@usap/uicomponents'
import React, { useCallback } from 'react'
import useManageLifetimeButtonWMO from '../hooks/useManageLifetimeButtonWMO'
import { OrderDetailsButtonContainer } from './style/button.css'
import { returnType } from './type'

const LifetimeReplacement = ({ data }) => {
    const {
        showReturn,
        navigateToRMA,
        partNumber,
        orderId,
        itemDetails,
    } = { ...data }

    const actionButtonClick = useCallback(() => {
        navigateToRMA(orderId, partNumber, `${'returnType='}${returnType.lifetime}`)
    }, [orderId, partNumber, navigateToRMA])

    const {
        Button, label, disabled,
    } = useManageLifetimeButtonWMO({
        showReturn,
        itemDetails,
    })

        return (
            <OrderDetailsButtonContainer style={{width: '100%'}}>
                <Button
                    custom
                    hideBorder
                    disabled={disabled}
                    onClick={actionButtonClick}
                    label={<Text size="small" color={'dark-2'}>{label}</Text>}
                />
            </OrderDetailsButtonContainer>
        )
}

export default LifetimeReplacement
